var windowWidth = window.innerWidth;

$(window).resize(function () {
    windowWidth = window.innerWidth;
});

if ($('#vehicle_model_page').data('range') === "True") {
    cookies.set("vt", "Cars", 30);
} else {
    cookies.set("vt", "Vans", 30);
}

function swapPaymentTypes(pricingType) {
    if (pricingType === 'Personal') {
        $('.personal_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.business_button').removeClass('is-active').addClass('btn-filter-inactive');
        $('.lowest-Price-Business').hide();
        $('.lowest-Price-Personal').show();
    }
    else if (pricingType === 'Business') {
        $('.business_button').removeClass('btn-filter-inactive').addClass('is-active');
        $('.personal_button').removeClass('is-active').addClass('btn-filter-inactive');
        $('.lowest-Price-Personal').hide();
        $('.lowest-Price-Business').show();
    }
};

$(document).ready(function () {
    $(document).on('click', '.business_button',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#pricing-filter-form");
            var dataSent = (form.serialize() !== "" && form.serialize() !== "?" ? form.serialize() + "&PricingType=" : "?PricingType=") + "Business" + "&SortBy=" + $('#order_by_desktop').val();
            if (windowWidth <= 1200 && $("#pricing-filter-form-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                dataSent = {
                    "BodyType": $('.quick-links-table.checked').children().data('model'),
                    "SpecLevel": $('.js-filter-radio[name="specLevel"]:checked').val(),
                    "FuelType": $('.js-filter-radio[name="fuelType"]:checked').val(),
                    "Transmission": $('.js-filter-radio[name="transmission"]:checked').val(),
                    "Drive": $('.js-filter-radio[name="drive"]:checked').val(),
                    "FactoryOptions": $('.js-filter-radio[name="factoryOption"]').parent('label.checked').children().map(function () { return $(this).val(); }).get().join(","),
                    "PricingType": "Business",
                    "Page": 1,
                    "SortBy": $('#order_by_mobile').val(),
                };
            }
            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        $('.lowest-Price-Personal').hide();
                        $('.lowest-Price-Business').show();
                        $('.business_button').removeClass('btn-filter-inactive').addClass('is-active');
                        $('.personal_button').removeClass('is-active').addClass('btn-filter-inactive');
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '.personal_button',
        function (e) {
            $('.js-options-loader').fadeIn();

            var form = $("#pricing-filter-form");
            var dataSent = (form.serialize() !== "" && form.serialize() !== "?" ? form.serialize() + "&PricingType=" : "?PricingType=") + "Personal" + "&SortBy=" + $('#order_by_desktop').val();
            if (windowWidth <= 1200 && $("#pricing-filter-form-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                dataSent = {
                    "BodyType": $('.quick-links-table.checked').children().data('model'),
                    "SpecLevel": $('.js-filter-radio[name="specLevel"]:checked').val(),
                    "FuelType": $('.js-filter-radio[name="fuelType"]:checked').val(),
                    "Transmission": $('.js-filter-radio[name="transmission"]:checked').val(),
                    "Drive": $('.js-filter-radio[name="drive"]:checked').val(),
                    "FactoryOptions": $('.js-filter-radio[name="factoryOption"]').parent('label.checked').children().map(function () { return $(this).val(); }).get().join(","),
                    "PricingType": "Personal",
                    "Page": 1,
                    "SortBy": $('#order_by_mobile').val(),
                };
            }

            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        $('.lowest-Price-Business').hide();
                        $('.lowest-Price-Personal').show();
                        $('.personal_button').removeClass('btn-filter-inactive').addClass('is-active');
                        $('.business_button').removeClass('is-active').addClass('btn-filter-inactive');
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', 'form input:radio, form input:checkbox',
        function (e) {
            if (windowWidth > 1200 && $(".secondary-filter-bar-sort-by-mobile:visible").length === 0) {
                if ($(this).prop('checked') && $(this).parent('label').hasClass('checked')) {
                    $(this).prop('checked', false);
                    $(this).parent('label').removeClass('checked');
                }
            }

            $(this).parent('label').siblings('label').removeClass('checked');
            $(this).parent('label').addClass('checked');
            $(this).addClass('checked');

            $('.js-options-loader').fadeIn();

            var bodyType = $('.quick-links-table.checked').children().data('model');
            var specLevel = $('.js-filter-radio[name="specLevel"]:checked').val();
            var fuelType = $('.js-filter-radio[name="fuelType"]:checked').val();
            var transmission = $('.js-filter-radio[name="transmission"]:checked').val();
            var drive = $('.js-filter-radio[name="drive"]:checked').val();
            var factoryOption = $('.js-filter-radio[name="factoryOption"]').parent('label.checked').children().map(function () { return $(this).val(); });
            var factoryOptionText = $('.js-filter-radio[name="factoryOption"]').parent('label.checked').children().map(function () { return $(this).attr('text'); });
            var pricingType = $('.pt-cookie.is-active').html();

            var form = $("#pricing-filter-form");

            var dataSent = (form.serialize() !== "" && form.serialize() !== "?" ? form.serialize() + "&PricingType=" : "PricingType=") + pricingType + "&SortBy=" + $('#order_by_desktop').val();
            if (windowWidth <= 1200 && $(".secondary-filter-bar-sort-by-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                $('#vehicle_model_page').removeClass((function (index, className) {
                    return (className.match(/(^|\s)popout-popout-filter-\S+/g) || []).join(' ');
                }));
                dataSent = {
                    "BodyType": $('.js-filter-radio[name="bodyType"]:checked').val(),
                    "SpecLevel": specLevel,
                    "FuelType": fuelType,
                    "Transmission": transmission,
                    "Drive": drive,
                    "FactoryOptions": factoryOption.get().join(","),
                    "PricingType": pricingType,
                    "Page": 1,
                    "SortBy": $('#order_by_mobile').val(),
                    "PopoutActive": true,
                    "OptionsPopoutActive": $(this).attr('name') === "factoryOption"
                };
            }

            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        swapPaymentTypes(pricingType);

                        if (bodyType !== undefined && bodyType.length > 0) { $('.filter-preview-options#filter-preview-body').text(bodyType); }
                        if (specLevel !== undefined && specLevel.length > 0) { $('.filter-preview-options#filter-preview-model').text(specLevel); }
                        if (fuelType !== undefined && fuelType.length > 0) { $('.filter-preview-options#filter-preview-fuel').text(fuelType); }
                        if (transmission !== undefined && transmission.length > 0) { $('.filter-preview-options#filter-preview-transmission').text(transmission); }
                        if (drive !== undefined && drive.length > 0) { $('.filter-preview-options#filter-preview-drive').text((drive === "1" ? "4WD" : "2WD")); }
                        if (factoryOptionText !== undefined && factoryOptionText.length > 0) {
                            var optionsText = '';
                            factoryOptionText.each(function (index, value) {
                                optionsText += value + ' | ';
                            });
                            optionsText = optionsText.slice(0, -2);
                            $('.filter-preview-options#filter-preview-options').text(optionsText);
                        }

                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });
    
    $(document).on('change', '#order_by_desktop',
        function (e) {
            $('.js-options-loader').fadeIn();
            var form = $("#pricing-filter-form");
            var pricingType = $('.pt-cookie.is-active').html();
            $.ajax(
                {
                    url: form.attr('action'),
                    data: (form.serialize() !== "" ? form.serialize() + "&PricingType=" : "PricingType=") + pricingType + "&SortBy=" + $(this).val() + "&Page=1",
                    type: "GET",
                    success: function (data) {
                        swapPaymentTypes(pricingType);
                        $("#vehicle-results").html(data);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('change', '#order_by_mobile',
        function (e) {
            $('.js-options-loader').fadeIn();
            var sort = $(this).val();
            var form = $("#pricing-filter-form-mobile");
            var pricingType = $('.pt-cookie.is-active').html();
            $.ajax(
                {
                    url: form.attr('action'),
                    data: {
                        "BodyType": $('.js-filter-radio[name="bodyType"]:checked').val(),
                        "SpecLevel": $('.js-filter-radio[name="specLevel"]:checked').val(),
                        "FuelType": $('.js-filter-radio[name="fuelType"]:checked').val(),
                        "Transmission": $('.js-filter-radio[name="transmission"]:checked').val(),
                        "Drive": $('.js-filter-radio[name="drive"]:checked').val(),
                        "FactoryOptions": $('.js-filter-radio[name="factoryOption"]').parent('label.checked').children().map(function () { return $(this).val(); }).get().join(","),
                        "PricingType": pricingType,
                        "Page": 1,
                        "SortBy": sort
                    },
                    type: "GET",
                    success: function (data) {
                        swapPaymentTypes(pricingType);
                        $('#order_by_mobile-header').val(sort);
                        $("#vehicle-results").html(data);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('change', '#order_by_mobile-header',
        function (e) {
            $('.js-options-loader').fadeIn();
            var sort = $(this).val();
            var form = $("#pricing-filter-form-mobile");
            var pricingType = $('.pt-cookie.is-active').html();
            $.ajax(
                {
                    url: form.attr('action'),
                    data: {
                        "BodyType": $('.js-filter-radio[name="bodyType"]:checked').val(),
                        "SpecLevel": $('.js-filter-radio[name="specLevel"]:checked').val(),
                        "FuelType": $('.js-filter-radio[name="fuelType"]:checked').val(),
                        "Transmission": $('.js-filter-radio[name="transmission"]:checked').val(),
                        "Drive": $('.js-filter-radio[name="drive"]:checked').val(),
                        "FactoryOptions": $('.js-filter-radio[name="factoryOption"]').parent('label.checked').children().map(function () { return $(this).val(); }).get().join(","),
                        "PricingType": pricingType,
                        "Page": 1,
                        "SortBy": sort
                    },
                    type: "GET",
                    success: function (data) {
                        swapPaymentTypes(pricingType);
                        $('#order_by_mobile').val(sort);
                        $("#vehicle-results").html(data);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', ".js-clear-filters, .js-clear-body-type",
        function (e) {
            $('.js-options-loader').fadeIn();

            e.preventDefault();
            var pricingType = $('.pt-cookie.is-active').html();
            var form = $("#pricing-filter-form");

            var dataSent = "PricingType=" + pricingType + "&SortBy=" + $('#order_by_desktop').val() + "&Reset=true";
            if (windowWidth <= 1200 && $("#pricing-filter-form-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                dataSent = "PricingType=" + pricingType + "&SortBy=" + $('#order_by_mobile').val() + "&PopoutActive=true&Reset=true";
            }

            $('form input:radio').prop('checked', false);
            $('form input:checkbox').prop('checked', false);
            $('form label').removeClass('checked', false);
            $('.quick-links-table').removeClass('checked').attr('onClick', '');
            $('.js-clear-body-type').parent('.quick-links-table').addClass('checked').attr('onClick', 'return false;');

            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $('#filter-preview-body').text();
                        $('#filter-preview-model').text();
                        $('#filter-preview-fuel').text();
                        $('#filter-preview-transmission').text();
                        $('#filter-preview-drive').text();
                        swapPaymentTypes(pricingType);
                        $("#vehicle-results").html(data);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '.js-paginate-btn',
        function (e) {
            $('.js-options-loader').fadeIn();

            e.preventDefault();
            var pricingType = $('.pt-cookie.is-active').html();

            var form = $("#pricing-filter-form");
            var dataSent = (form.serialize() !== "" && form.serialize() !== "?" ? form.serialize() + "&PricingType=" : "PricingType=") + pricingType + "&SortBy=" + $('#order_by_desktop').val() + "&Page=" + $(this).data('page');
            if (windowWidth <= 1200 && $("#pricing-filter-form-mobile:visible").length > 0) {
                form = $("#pricing-filter-form-mobile");
                dataSent = {
                    "BodyType": $('.js-filter-radio[name="bodyType"]').parent('label.checked').children(':checked').val(),
                    "SpecLevel": $('.js-filter-radio[name="specLevel"]').parent('label.checked').children(':checked').val(),
                    "FuelType": $('.js-filter-radio[name="fuelType"]').parent('label.checked').children(':checked').val(),
                    "Transmission": $('.js-filter-radio[name="transmission"]').parent('label.checked').children(':checked').val(),
                    "Drive": $('.js-filter-radio[name="drive"]').parent('label.checked').children(':checked').val(),
                    "FactoryOptions": $('.js-filter-radio[name="factoryOption"]').parent('label.checked').children().map(function () { return $(this).val(); }).get().join(","),
                    "PricingType": pricingType,
                    "Page": $(this).data('page'),
                    "SortBy": $('#order_by_mobile').val()
                };
            }
            $.ajax(
                {
                    url: form.attr('action'),
                    data: dataSent,
                    type: "GET",
                    success: function (data) {
                        $("#vehicle-results").html(data);
                        $("html, body").animate({
                            scrollTop: $('#vehicle-results').offset().top - 75
                        }, 200);
                        $('.js-options-loader').fadeOut();
                    }
                });
        });

    $(document).on('click', '#mobile-filter-trigger',
        function (e) {
            $('#vehicle-listing').fadeOut();
        });

    $(document).on('click', '.js-close-active-popouts',
        function (e) {
            $('.popout.js-popout.mod-popout-filter.js-popout-filter-last').hide();
            $('.popout.js-popout.mod-popout-filter.js-popout-filter-last').css('display', 'none');
            $('#vehicle-listing').fadeIn();
        });
});